/*@ngInject*/
const CollaborationNotifyTaskRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.notifyTaskAssignee = function (taskId) {
        let url = `/rest/SubmissionTask/${taskId}/notifyTaskAssignee`;

        return this.post(url);
    };

};

angular.module('gw-um-submission')
    .service('collaborationNotifyTaskRepository', CollaborationNotifyTaskRepository);
